import apiClient from 'apiClient';
import { CasesResponse } from './types';

export const getCases = (params: Record<string, any>): CasesResponse => {
  return apiClient.get('/api/v1/cases/list/', { params });
};
